import {
    VerificationStep,
    logger,
    getOptions,
} from '@sheerid/jslib';
import {
    QUERY_STRING_PREV_STEP_OVERRIDE,
} from '../../constants';

// When loading the error step, specify an errorId
// eslint-disable-next-line consistent-return
export const getPreviousStepOverride = (): VerificationStep | undefined => {
    try {
        const parsed: URLSearchParams = new URLSearchParams(window.location.search);

        if (parsed.get(QUERY_STRING_PREV_STEP_OVERRIDE)) {
            return parsed.get(QUERY_STRING_PREV_STEP_OVERRIDE) as VerificationStep;
        }
        // @ts-expect-error
        if (getOptions()[QUERY_STRING_PREV_STEP_OVERRIDE]) {
            // @ts-expect-error
            return getOptions()[QUERY_STRING_PREV_STEP_OVERRIDE];
        }
    } catch (e) {
        logger.error(e as any, QUERY_STRING_PREV_STEP_OVERRIDE);
    }
};
